import React, { Component } from "react";
import "./styles.css";
import FormContent, { createComponent } from "../FormArea/FormContent";
import FilterArea from "../PushkarFilter/FilterArea";
import ReportArea from "../ReportArea";

const ControlSearch = ({ parentState, parentProps, liftGlobalState, liftState, liftWrapperState }) => {
  let { openControls, screen } = parentState;

  const closeModal = () => {
    openControls.pop();
    liftGlobalState({ name: 'openControls' }, openControls);
  }

  const handleModalClose = (e) => {
    if (e.keyCode == 27) {
      closeModal();
    }
  }
  document.addEventListener("keyup", handleModalClose, false);

  let newparentState = { ...parentState };
  let lastcontrol = openControls[openControls.length - 1];
  newparentState.currentPage = lastcontrol.fastpath;
  newparentState.isSearching = lastcontrol.isSearching;

  newparentState.LocalVars = lastcontrol.LocalVars ? lastcontrol.LocalVars : { ...parentState.LocalVars };
  newparentState.isSearching = lastcontrol.isSearching ? lastcontrol.isSearching : parentState.isSearching;
  // newparentState.LocalVars = lastcontrol.LocalVars;

  return (
    <div className="control-search-container" style={{ height: screen.height - 60 }}>
      <div className="col-sm-12 right modal-close-btn-container" ><div className="hand modal-close-btn" onClick={closeModal}>CLOSE</div></div>
      <div className="control-search-form">
        {/* <FormContent
          parentState={parentState}
          liftState={liftState}
          liftGlobalState={liftGlobalState}
          parentProps={parentProps}
        /> */}

        <FilterArea
          liftState={liftState}
          liftGlobalState={liftGlobalState}
          liftWrapperState={liftWrapperState}
          parentState={newparentState}
          parentProps={parentProps}
        />

        <ReportArea
          liftState={liftState}
          liftGlobalState={liftGlobalState}
          liftWrapperState={liftWrapperState}
          parentState={newparentState}
          parentProps={parentProps}
        />

      </div>
    </div>
  )
}


export default ControlSearch;